<template>
    <div class="help-container">
        <span class="title">
            {{helpData.modelName}}
            <slot name="slotL"
                  class="left-slot" />
            <i v-if="message!==''"
               @click="puckerSelect"
               :class="{true: 'icon-explanation-1-o icon-active', false: 'icon-explanation-1-o'}[is_upfold]"></i>
        </span>
        <div class="help-font"
             v-if="is_upfold">
            <div class="tooltip bottom fade in">
                <div class="tooltip-arrow"
                     :style="positionStyle"
                     style="top:-8px;position:absolute;border-bottom-color:#eaf3fd"></div>
            </div>
            <div class="help-info">
                <div style="color: #666;cursor: auto;padding:0;margin:0px"
                     v-html="$t(message)"></div>
            </div>
        </div>
        <div v-if="helpData.showBack"
             class="back-div pull-right"
             @click="$router.go(-1)">
            <Icon type="ios-arrow-dropleft"
                  size="16" />
            <span>{{$t('返回')}}</span>
        </div>
        <div class="pull-right"
             style="padding-right: 15px;">
            <slot name="slotR"></slot>
        </div>
    </div>
</template>

<script>
import { helpInfoMap } from '@/service/helpService'
export default {
    name: 'helpTitle',
    props: ['helpData'],
    data () {
        return {
            message: '',
            is_upfold: false,
            headerRowStyle: '',
            positionStyle: ''
        }
    },
    watch: {
        helpData (val) {
            this.init()
        }
    },
    created: function () {
        this.init()
    },
    methods: {
        puckerSelect: function (e) {
            this.is_upfold = !this.is_upfold
        },
        init () {
            var key = this.helpData.modelName
            var value = helpInfoMap[key]
            if (value !== undefined) {
                this.message = value
            }
        }
    }
}
</script>

<style lang="less" scoped>
.help-container {
    width: calc(~'100% - 1px');
    min-height: 46px;
    line-height: 46px;
    padding-left: 11px;
    border-bottom: 1px solid #e9e9e9;
    position: relative;
    z-index: 10;
    background: #fff;
    font-size: 14px;
    margin-left: 1px;
    .slot-left {
        display: inline-block;
    }
    .title {
        font-weight: 500;

        i {
            position: relative;
            top: 2px;
            left: 2px;
            font-size: 16px;
        }
    }
    .back-div {
        width: 90px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        border-left: 1px solid #f3f3f3;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        span {
            position: relative;
            font-size: 12px;
            top: -1px;
            left: 3px;
        }
    }
    .back-div:hover {
        color: #ff6a01;
    }
    .help-font {
        padding: 0px;
        font-size: 12px;
        clear: both;
        position: relative;
        margin-bottom: 14px;
        margin-right: 10px;
        span {
            margin-left: 10px;
            color: #0a83f6;
            cursor: pointer;
        }
        .help-info {
            line-height: 22px;
            padding: 20px;
            background-color: #eaf3fd;
            margin-bottom: 0px;
        }
        .pucker-pos-row {
            position: absolute;
            right: 15px;
            cursor: pointer;
            top: 18px;
        }
    }
    .icon-active {
        cursor: pointer;
        color: #4da2ec;
    }
    .tooltip.bottom {
        padding: 5px 0;
        margin-top: 3px;
        margin-left: 20px;
    }
    .tooltip.in {
        opacity: 0.9;
    }
    .tooltip {
        position: absolute;
        z-index: 1070;
        display: block;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: left;
        text-align: start;
        text-decoration: none;
        text-shadow: none;
        text-transform: none;
        letter-spacing: normal;
        word-break: normal;
        word-spacing: normal;
        word-wrap: normal;
        white-space: normal;
        filter: alpha(opacity=0);
        opacity: 0;
        line-break: auto;
        .tooltip-arrow {
            width: 0;
            height: 0;
            border-color: transparent;
            border-style: solid;
            margin-left: -5px;
            border-width: 0 5px 5px;
        }
    }
}
</style>
